import type { FC, ReactNode } from 'react'
import { Chiclet } from 'sutra/components/Chiclet/Chiclet'

import {
  ChicletsRow,
  IconWrapper,
  LabelRow,
  MenuItemContainer,
  MenuItemDescription,
  MenuItemLabel,
} from 'features/charts-v2/components/ChartTypePicker/chart-type-picker.styles'
import type { ChicletConfig } from 'features/charts-v2/types/chart-types'

interface PresetMenuItemProps {
  icon: ReactNode
  label: string
  description: string
  chiclets: ChicletConfig[]
  onClick: () => void
  disabled?: boolean
  isSelected?: boolean
}

/** One row of a `ChartTypePicker` submenu — a preset, or an extra-section
 *  item (which passes an empty `chiclets` array; only presets carry them). */
export const PresetMenuItem: FC<PresetMenuItemProps> = ({
  icon,
  label,
  description,
  chiclets,
  onClick,
  disabled = false,
  isSelected = false,
}) => (
  <MenuItemContainer
    $disabled={disabled}
    $isSelected={isSelected}
    onClick={onClick}
  >
    <IconWrapper>{icon}</IconWrapper>
    <div>
      <LabelRow>
        <MenuItemLabel>{label}</MenuItemLabel>
        {chiclets.length > 0 && (
          <ChicletsRow>
            {chiclets.map((chiclet, index) => (
              <Chiclet key={index} icon={chiclet.icon} $tone={chiclet.tone}>
                {chiclet.text}
              </Chiclet>
            ))}
          </ChicletsRow>
        )}
      </LabelRow>
      <MenuItemDescription>{description}</MenuItemDescription>
    </div>
  </MenuItemContainer>
)
